import { ChangeAnalysisAiTable } from "@/pages/dashboard/pages/changeAnalysis/components/ChangeAnalysisAiTable";
import ChangeAnalysisCountryRegionChart from "@/pages/dashboard/pages/changeAnalysis/components/ChangeAnalysisCountryRegionChart";
import ViewportFullscreenShell from "@/pages/dashboard/components/ViewportFullscreen";
import ChangeAnalysisTrendCard from "@/pages/dashboard/pages/changeAnalysis/components/ChangeAnalysisTrendCard";
import { ChangeAnalysisAbnormalAttributionTable } from "@/pages/dashboard/pages/changeAnalysis/components/ChangeAnalysisAbnormalAttributionTable";
import RankingChangeTable from "@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable";
import { RankingChangeTableHeader } from "@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/components/RankingChangeTableHeader";
import { RankingChangeTableChangeBubble } from "@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/components/RankingChangeTableChangeBubble";
import ChangeAnalysisMultiTrendPanel from "@/pages/dashboard/pages/changeAnalysis/components/ChangeAnalysisMultiTrendPanel";

export default {
  ChangeAnalysisTrendCard,
  ViewportFullscreenShell,
  ChangeAnalysisCountryRegionChart,
  ChangeAnalysisAiTable,
  ChangeAnalysisAbnormalAttributionTable,
  RankingChangeTable,
  RankingChangeTableHeader,
  RankingChangeTableChangeBubble,
  ChangeAnalysisMultiTrendPanel,
};
